export const optimiseImageUrl = (url: string, width?: string | number, height?: string | number, customParams?: string): string => {

  // if url is empty, return empty string 
  if (!url) {
    return '';
  }

  // if image is in base64 format or does not start with https://images.prismic.io/, return as it is
  if (url.startsWith('data:image') || url.indexOf('https://images.prismic.io/') === -1) {
    return url;
  }

  // remove all query params and add imgix optimisation params
  const urlWithoutQueryParams = url.split('?')[0];
  let params = '?auto=format,compress';

  if (width) {
    params = params.concat(`&w=${width}`);
  }
  if (height) {
    params = params.concat(`&h=${height}`);
  }
  if (customParams) {
    params = params.concat(`&${customParams}`);
  }

  return `${urlWithoutQueryParams + params}`;
};
